import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import $ from "jquery";
import Moment from 'moment'
import "react-toastify/dist/ReactToastify.css";

class UserBuyFundModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id:"this.props.user.id",
      userData: [],
      dataStatus: false,
      // portfolioUsdt:0,
      // portfolioInr:0
    };
    console.log("this.props",this.props)
  }

  componentWillReceiveProps(nextProps) {
    console.log("nextProps.currentRecordData",nextProps.buyOrderDataById)
    if (nextProps.buyOrderDataById) {
      this.setState({
        userData: nextProps.buyOrderDataById.result,
        dataStatus: nextProps.buyOrderDataById.success,
      });
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  tableDataHtml = () => {
    if (this.state.dataStatus == true) {
      const html = [];
      const classThis = this;
      console.log("user buy",this.state.userData.length)
      if(this.state.userData.length>0){
        this.state.userData.map((value, i) => {
          html.push(
            <tr>
              <td>{i + 1}</td>
              <td>
                {value.PairId.firstCoin.shortName} / {value.PairId.secondCoin.shortName}
              </td>
              <td>
                {value.Purchaseprice}
              </td>
              <td>{value.qty}</td>
              <td>{value.Trade}</td>
              {/* <td>{value.buy_fees}</td> */}
              <td>{value.orderStatus}</td>
              <td>{Moment.utc(value.createdaT).local().format("lll")}</td>
            </tr>
          );
        });
      }
      else{
        html.push(
          // <tr>
          <p className="text-center">No record found</p>
          // {/* </tr> */}
        );
      }
    
      return html;
    }
  };

  render() {
    const { errors } = this.state;
    return (
      <div>
        <div className="modal fade" id="update-userbuy-modal" data-reset="true" data-backdrop="static">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">User Buy Order History</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <table className="table w-100">
                  <thead>
                    <tr>
                    <th>S.No.</th>
                      <th>Pair</th>
                      <th>Buy Price</th>
                      <th>Quantity</th>
                      <th>Trade Amount</th>
                      {/* <th>Buy Fees</th> */}
                      <th>Status</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>{this.tableDataHtml()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserBuyFundModal.propTypes = {
  userFundHistory: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps)(withRouter(UserBuyFundModal));
